import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { MFAActionType, MFACallback, MFAResponse } from "../models";
import { SvcServices } from "./svc.service";
import { MFAService } from "./mfa.service";


// Derives the cookie Domain from the current host so it matches the deployed
// environment at runtime (the browser bundle is built once, so a build-time
// environment value cannot be used). Returns the registrable parent domain
// (eTLD+1) prefixed with a dot, e.g. 'uat10.mobile.citibank.com' -> '.citibank.com',
// 'www.citibankonline.com' -> '.citibankonline.com'.
export function deriveCookieDomain(hostname: string): string {
    const parts = (hostname || '').split('.').filter(Boolean);
    return parts.length >= 2 ? '.' + parts.slice(-2).join('.') : hostname;
}

@Injectable()
export class SignonService{

    constructor(
        private _svcServices : SvcServices,
        private mfaService : MFAService
    ){}

    private processIndicatorMap = new Map<string, {route: string, pageName: string}>([
        ['dashboard', {route: '/credithome', pageName: 'credithome'}],
        ['makepaymentoptions', {route: '/paymentwithoptions', pageName: 'make_a_payment_with_options'}],
        ['autopay', {route: '/autopay', pageName: 'autopay'}],
        ['securemessage', {route: '/securemessage/newsecuremessage', pageName: 'new_message'}],
        ['payments', {route: '/payments', pageName: 'payments'}],
        ['statements', {route: '/statements', pageName: 'statements'}],
        ['profile', {route: '/profile', pageName: 'profile'}],
        ['creditlineincrease', {route: '/requestcreditlimitincrease', pageName: 'requestcreditlimitincrease'}],
        ['creditLineInc', {route: '/requestcreditlimitincrease', pageName: 'requestcreditlimitincrease'}],
        ['manageaccount', {route: '/manageaccount', pageName: 'manageaccount'}],
        ['lostorstolen', {route: '/lostorstolen', pageName: 'report_lost_or_stolen_card'}],
        ['replacementcard', {route: '/requestreplacementcard', pageName: 'request_replacement_card'}],
        ['disputecharge', {route: '/disputes', pageName: 'dispute_charge'}],
        ['citialert', {route: '/citialert', pageName: 'citialert'}],
        ['paperless', {route: '/paperless', pageName: 'paperless'}],
        ['helpcontact', {route: '/helpcontact', pageName: 'helpcontact'}],
        ['linkadditionalcards', {route: '/linkadditionalcards', pageName: 'linkadditionalcards'}],
        ['managepaymentsrc', {route: '/managepaymentsources', pageName: 'manage_payment_sources'}],
        ['faqlibrary', {route: '/faqlibrary', pageName: 'faqlibrary'}],
        ['addauthusers', {route: '/addauthusers', pageName: 'add_authorized_users'}],
        ['linkadditionalcard', {route: '/linkadditionalcard', pageName: 'linkadditionalcard'}],
        ['balanceTransfer', {route: '/balancetransfer', pageName: 'balance_transfer'}],
        ['rsedi', {route: '/rsedi', pageName: 'ratesale_edi'}],
        ['myoffers', {route: '/offers', pageName: 'offers'}],
        
    ]);

    public redirectToProcessIndicatorPage(processInd: string, siteId: string, langId: string, cmp?: string): void {
        const processInfo = this.processIndicatorMap.get(processInd);

        if (!processInfo) {
            console.warn(`Process indicator "${processInd}" not found in the map. Redirecting to signon.`);
            this.redirectToSignon(siteId, langId, cmp, processInd);
            return;
        }

        const isLinkAdditionalCardPage = this.isLinkAdditionalCardProcess(processInfo.pageName);
        const isMacysBloomingdaleSite = this.isEligibleSiteForLinkCard(siteId);

        const url = this.buildUrl(processInfo, isLinkAdditionalCardPage, isMacysBloomingdaleSite, siteId, langId, cmp);

        console.log("Deep drop URL:", url);
        window.location.href = url;
    }

    private isLinkAdditionalCardProcess(pageName: string): boolean {
        return pageName === 'linkadditionalcards' || pageName === 'linkadditionalcard';
    }

    private isEligibleSiteForLinkCard(siteId: string): boolean {
        return siteId === "PLCN_MACYS" || siteId === "PLCN_BLOOMINGDALES";
    }

    private buildUrl(processInfo: {route: string, pageName: string}, isLinkAdditionalCardPage: boolean, isEligibleSite: boolean, siteId: string, langId: string, cmp?: string): string {
        const baseUrl = isLinkAdditionalCardPage && isEligibleSite
            ? `/RSag/linkadditionalcard`
            : `/RSag${processInfo.route}`;

        const queryParams = new URLSearchParams({
            pageName: isLinkAdditionalCardPage && isEligibleSite ? 'linkadditionalcard' : processInfo.pageName,
            siteId,
            langId
        });

        if (cmp) {
            queryParams.set('cmp', cmp);
        }

        return `${baseUrl}?${queryParams.toString()}`;
    }


    public setV66ForScTracking(pageName: string = 'single_sign_on'): void {
        try {
            sessionStorage.setItem('v66', pageName);
            sessionStorage.setItem('prev_v66', pageName);
            sessionStorage.setItem('previousPageName', pageName);
        } catch(e) {
            console.warn('Failed to set v66 tracking in sessionStorage', e);
        }
    }

public redirectToSignon(siteId: string, langId: string = 'en_US', cmp?: string, processIndicator?: string, channelId?: string): void {  
    let baseUrl: string;  
    const queryParams = new URLSearchParams();  
  
    if (siteId === 'PLCN_MACYS' || siteId === 'PLCN_BLOOMINGDALES') {  
        baseUrl = '/RSag/systemdown';   
        queryParams.set('pageName', 'systemdown');  
        queryParams.set('siteId', this._svcServices.getSiteId());  
        if (processIndicator) {
            queryParams.set('processIndicator', processIndicator);
        }
        if (channelId) {
            queryParams.set('channelId', channelId);
        }
    } else {  
        baseUrl = '/RSauth/signon';  
        queryParams.set('pageName', 'signon');  
        queryParams.set('siteId', siteId);  
    }  
  
    queryParams.set('langId', langId);  
    if (cmp) {  
        queryParams.set('cmp', cmp);  
    }  
    if (processIndicator) {
        queryParams.set('processIndicator', processIndicator);
    }
  
    window.location.href = `${baseUrl}?${queryParams.toString()}`;  
}

    public triggerGenAuthCode(accountId: any, headerData: any): Observable<any> {
        const responseSubject = new Subject<any>();

        const authCodeMFACallback: MFACallback = ((authCodeResp: MFAResponse) => {
          let result = {
            eligibilityCheck: true,
            errorCode: null
          };

          if (authCodeResp?.response && authCodeResp.response.error == null &&
            (authCodeResp.mfaActionType === MFAActionType.ALLOW || authCodeResp.mfaActionType === MFAActionType.CHALLENGE_SUCCESS || authCodeResp.mfaActionType === MFAActionType.CHALLENGE_FAILURE)) {
            sessionStorage.setItem('SSOLoginSuccess', "true");
            sessionStorage.setItem('isSSOLinkingFlow', "true");
            document.cookie = `isSSOLinkingFlow=true; path=/; domain=${deriveCookieDomain(window.location.hostname)}; max-age=300; SameSite=None; Secure`;
            if (authCodeResp.response.body && authCodeResp.response?.body?.redirectUrl) {
              result.eligibilityCheck = false;
              responseSubject.next(result);
              responseSubject.complete();
              window.open(authCodeResp.response.body.redirectUrl, "_self");
              return responseSubject.asObservable();
            } else {
              console.warn("SSO response missing redirectUrl");
              result.eligibilityCheck = true;
              result.errorCode = 'MISSING_REDIRECT_URL';
              responseSubject.next(result);
              responseSubject.complete();
              return responseSubject.asObservable();
            }
          } else if (authCodeResp?.response?.error?.status === 400) {
            result.eligibilityCheck = true;
            result.errorCode = 'USERID_ALREADY_LINKED';
            responseSubject.next(result);
            responseSubject.complete();
            return responseSubject.asObservable();
          } else if (authCodeResp.mfaActionType === MFAActionType.DENY) {
            result.eligibilityCheck = false;
            result.errorCode = 'MFA_DENY';
            responseSubject.next(result);
            responseSubject.complete();
            return responseSubject.asObservable();
          } else if (authCodeResp.mfaActionType === MFAActionType.DEVDENY) {
            result.eligibilityCheck = false;
            result.errorCode = 'MFA_DEVDENY';
            responseSubject.next(result);
            responseSubject.complete();
            return responseSubject.asObservable();
          } else if (authCodeResp.mfaActionType === MFAActionType.CANCEL) {
            result.eligibilityCheck = false;
            result.errorCode = 'MFA_CANCEL';
            responseSubject.next(result);
            responseSubject.complete();
            return responseSubject.asObservable();
          } else {
            console.log("Auth Code CALL FAILURE");
            result.eligibilityCheck = false;
            result.errorCode = 'GEN_AUTH_CODE_FAILURE';
            responseSubject.next(result);
            responseSubject.complete();
            return responseSubject.asObservable();
          }

        }).bind(this); { }


        // SSO Flow ==> oauth/genAuthCode
        const authCodeRequest = {
          "siteId": headerData?.siteId?.toUpperCase() || this._svcServices.getSiteId(),
          "partnerUserId": sessionStorage.getItem("ssoPartnerUserId") || '',
          "partnerRedirectUrl": sessionStorage.getItem("ssoPartnerRedirectUrl") || '',
          "state": sessionStorage.getItem("ssoState") || '',
          "accountId": accountId || ''
        }

        this.mfaService.interdictwithHeader('oauth/genAuthCode', 'post', authCodeRequest, authCodeMFACallback, 2, headerData, true);

        return responseSubject.asObservable();

    }

}